<script setup lang="ts">
import { Form, Head } from "@inertiajs/vue3"
import { LoaderCircle } from "lucide-vue-next"

import InputError from "@/components/InputError.vue"
import PasswordInput from "@/components/PasswordInput.vue"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import AuthLayout from "@/layouts/AuthLayout.vue"
import { userPasswordPath } from "@/routes"

interface Props {
  reset_password_token: string
}

const props = defineProps<Props>()
</script>

<template>
  <AuthLayout
    title="Reset password"
    description="Please enter your new password below"
  >
    <Head title="Reset password" />

    <Form
      method="put"
      :action="userPasswordPath()"
      :transform="(data) => ({ ...data, reset_password_token: props.reset_password_token })"
      :resetOnSuccess="['password', 'password_confirmation']"
      #default="{ errors, processing }"
    >
      <div class="grid gap-6">
        <div class="grid gap-2">
          <Label for="password">New password</Label>
          <PasswordInput
            id="password"
            name="password"
            autocomplete="new-password"
            class="mt-1 block w-full"
            autofocus
            placeholder="New password"
          />
          <InputError :messages="errors.password" />
        </div>

        <div class="grid gap-2">
          <Label for="password_confirmation">Confirm new password</Label>
          <PasswordInput
            id="password_confirmation"
            name="password_confirmation"
            autocomplete="new-password"
            class="mt-1 block w-full"
            placeholder="Confirm password"
          />
          <InputError :messages="errors.password_confirmation" />
        </div>

        <Button type="submit" class="mt-4 w-full" :disabled="processing">
          <LoaderCircle v-if="processing" class="h-4 w-4 animate-spin" />
          Reset password
        </Button>
      </div>
    </Form>
  </AuthLayout>
</template>
